'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('vnext.content.goals', {
      url: 'goals',
      templateUrl: 'goals/templates/goals-main.html',
      controller: 'GoalsCtrl',
      controllerAs: '$ctrl',
      data: {
        pageTitle: 'pageTitles.goals'
      },
      resolve: {
        goalsList: ['goalSvc', function (goalSvc) {
          return goalSvc.fetchGoalsAndHabits().then(function (resp) {

            // For plotting consistency, title = name.
            resp.forEach(function (goal) {
              goal.sections.forEach(function (habit) {
                habit.title = habit.name;
              });
            });

            return resp;
          });
        }]
      }
    });
  }]);
})();